"use client";
import Plus from "@/assets/svg/16/Plus";
import Minus from "@/assets/svg/Minus";
import clsx from "clsx";
import styles from "./index.module.css";

import React, { forwardRef } from 'react';

type AccRootProps = React.ComponentProps<"div"> & { ref?: React.Ref<HTMLDivElement> };
const Root = forwardRef<HTMLDivElement, AccRootProps>(({ className, children, ...rest }, ref) => {
  return (
    <div ref={ref} className={clsx(className, styles.root)} {...rest}>
      {children}
    </div>
  );
});
Root.displayName = "AccordionRoot"

type AccItemProps = React.ComponentProps<"details"> & { ref?: React.Ref<HTMLDetailsElement> };
const Item = forwardRef<HTMLDetailsElement, AccItemProps>(({ className, children, ...rest }, ref) => {
  return (
    <details ref={ref} className={clsx(className, styles.item)} {...rest}>
      {children}
    </details>
  );
});
Item.displayName = "AccordionItem"

type AccTriggerProps = React.ComponentProps<"summary"> & { ref?: React.Ref<HTMLElement> };
const Trigger = forwardRef<HTMLElement, AccTriggerProps>(({ className, children, ...rest }, ref) => {
  return (
    <summary ref={ref} className={clsx(className, styles.trigger)} {...rest}>
      {children}
      <div className={styles.arrow__down}>
        <Plus />
      </div>
      <div className={styles.arrow__up}>
        <Minus />
      </div>
    </summary>
  );
});
Trigger.displayName = "AccordionTrigger"

type AccContentProps = React.ComponentProps<"div"> & { ref?: React.Ref<HTMLDivElement> };
const Content = forwardRef<HTMLDivElement, AccContentProps>(({ className, children, ...rest }, ref) => {
  return (
    <div ref={ref} className={clsx(className, styles.content)} {...rest}>
      {children}
    </div>
  );
});
Content.displayName = "AccordionContent"

const Accordion = ({
  items
}: {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}) => {
  return (
    <Root>
      {items?.map((item, i) => {
        return (
          <Item key={i}>
            <Trigger>{item.title}</Trigger>
            <Content>{item.content}</Content>
          </Item>
        );
      })}
    </Root>
  );
};

// Exports
export {
  Content as AccordionContent,
  Item as AccordionItem,
  Root as AccordionRoot,
  Trigger as AccordionTrigger,
  // Overrides for legacy code
  Content as ClientAccordionContent,
  Item as ClientAccordionItem,
  Root as ClientAccordionRoot,
  Trigger as ClientAccordionTrigger,
  // Export Accordion as default
  Accordion as default
};
